<template>
  <div class="discuss">
    <h2 class="discuss__header">DISCUSS</h2>
    <div class="discuss__content">
      <div class="discuss__info">
        <h3>
          <a :href="link">{{ link }}</a>
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    link: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped lang="scss">
@import "./../../../../assets/styles/vars";

///////////////////////////
// DISCUSS
// TODO: move to separate file
///////////////////////////////

.discuss {
  position: relative;
  min-height: 112px;
  color: #fff;
  background-color: #333;
  margin-bottom: 2em;
}

.discuss__header {
  position: relative;
  display: inline-block;
  margin: 0 40px 0 0;
  padding: 0 25px;
  font-family: $sarala;
  font-size: 22px;
  line-height: 112px;
  letter-spacing: 0.025em;
  background-color: $mainRed;

  &::after {
    content: "";
    position: absolute;
    top: 52%;
    right: -22px;
    transform: translate(0, -50%);
    display: block;

    width: 0;
    height: 0;
    border-top: 22px solid transparent;
    border-bottom: 22px solid transparent;
    border-left: 22px solid $mainRed;
  }

  @media (max-width: $screen-lg) {
    padding: 0 20px;
  }

  @media (max-width: $screen-sm) {
    display: block;
    line-height: 50px;
    margin: 0;

    &::after {
      display: none;
    }
  }
}

.discuss__content {
  display: inline-block;

  @media (max-width: $screen-sm) {
    position: relative;
    display: block;
  }
}

.discuss__icon {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin: 0 30px 0 35px;
  width: 74px;
  height: 74px;
  background-color: #989898;
  border-radius: 50%;

  text-align: center;
  line-height: 74px;
  font-size: 30px;
  color: #adadad;

  &::after {
    content: "";
    position: absolute;
    right: -15px;
    top: 0;
    bottom: 0;
    display: inline-block;
    width: 1px;
    background-color: $mainRed;
  }

  @media (max-width: $screen-lg) {
    margin: 0 25px;
  }

  @media (max-width: $screen-sm) {
    position: absolute;
    top: 50%;
    left: 15px;
    transform: translateY(-50%);
    margin: 0;
    width: 39px;
    height: 39px;
    line-height: 39px;
    font-size: 24px;

    &::after {
      display: none;
    }
  }

  @media (max-width: $screen-xs) {
    left: 10px;
  }
}

.discuss__info {
  display: inline-block;
  vertical-align: middle;
  font-family: $metron;
  font-size: 11px;

  h3 {
    margin: 0 0 6px;
    font-size: 18px;
  }

  p {
    margin: 0;
    font-size: 14px;
  }

  a {
    &:hover {
      color: $mainRed;
    }
  }

  ul {
    margin: 0 0 2px;
    padding: 0;
    list-style-type: none;

    // just steal this code from forum.dayz
    // TODO: use some font icon font or svg instead img from external resource
    padding-left: 20px;
    background-image: url("https://forums.dayz.com/uploads/set_resources_8/d0e70b4cbb9ab8afb1bc1065a3f8487a_subitem_stem.png");
    background-position: 3px 5px;
    background-repeat: no-repeat;
    background-size: 13px 5px;

    li {
      display: inline-block;
      margin-right: 5px;
    }
  }

  @media (max-width: $screen-sm) {
    margin: 10px;
  }
}

.discuss__amount {
  display: inline-block;
  vertical-align: middle;
  margin-left: 30px;
  text-align: center;
  font-family: $metron;
  font-size: 12px;

  .bigger {
    font-size: 21px;
  }

  @media (max-width: $screen-lg) {
    //margin-left: 20px;
    display: none;
  }

  @media (max-width: $screen-md) {
    display: none;
  }
}

.discuss__avatar {
  display: inline-block;
  vertical-align: middle;
  margin-left: 30px;
  width: 39px;
  height: 39px;

  @media (max-width: $screen-lg) {
    margin-left: 20px;
  }

  @media (max-width: $screen-md) {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    margin: 0;
  }

  @media (max-width: $screen-xs) {
    right: 10px;
  }
}

.discuss__details {
  display: inline-block;
  vertical-align: middle;
  margin: 0 0 0 20px;
  padding: 0;
  list-style-type: none;

  li {
    font-family: $metron;
    font-size: 12px;
    line-height: 2;
  }

  strong {
    font-family: $sarala;
  }

  @media (max-width: $screen-lg) {
    margin-left: 20px;
  }

  @media (max-width: $screen-md) {
    display: none;
  }
}
</style>
